/* Folketsval homepage behaviour. Loaded on the index template only. Progressive enhancement:
   without this file the tiles are plain in-page anchors to #shop and every gift stays visible. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fvh-gifts]');
  if (!root) return;

  var grid = root.querySelector('[data-fvh-grid]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-fvh-tile]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('.fvh-card'));
  var status = root.querySelector('[data-fvh-status]');
  var label = root.querySelector('[data-fvh-label]');
  var reset = root.querySelector('[data-fvh-reset]');
  var anchor = document.getElementById('shop');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = '';
  var timer = 0;

  function tileText(tile) {
    var el = tile.querySelector('.fvh-tile__label');
    return el ? el.textContent.trim() : '';
  }

  function paint(id) {
    active = id || '';
    var filtering = !!active;
    if (filtering) grid.setAttribute('data-filtering', ''); else grid.removeAttribute('data-filtering');
    cards.forEach(function (card) {
      var groups = card.getAttribute('data-groups') || '';
      var match = filtering && groups.indexOf('|' + active + '|') > -1;
      card.classList.toggle('is-match', filtering && match);
      card.classList.toggle('is-off', filtering && !match);
      card.classList.remove('is-hit');
    });
    tiles.forEach(function (tile) {
      if (tile.getAttribute('data-fvh-tile') === active) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
    });
    if (status) {
      status.hidden = !filtering;
      if (filtering && label) {
        var current = tiles.filter(function (t) { return t.getAttribute('data-fvh-tile') === active; })[0];
        label.textContent = current ? tileText(current) : '';
      }
    }
    if (filtering) {
      window.clearTimeout(timer);
      // restart the ring on the matching cards on the next frame so the animation replays
      window.requestAnimationFrame(function () {
        cards.forEach(function (card) { if (card.classList.contains('is-match')) card.classList.add('is-hit'); });
        timer = window.setTimeout(function () { cards.forEach(function (card) { card.classList.remove('is-hit'); }); }, 1300);
      });
    }
  }

  function toGrid() {
    if (!anchor) return;
    anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function (event) {
      event.preventDefault();
      var id = tile.getAttribute('data-fvh-tile');
      // the "everything" tile and a second tap on the active tile both clear the filter
      if (tile.hasAttribute('data-fvh-all') || id === active) paint('');
      else paint(id);
      toGrid();
    });
  });

  if (reset) {
    reset.addEventListener('click', function () { paint(''); });
  }
})();
